<template>
    <LayoutDefault>
        <Categories/>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault";
import Categories from "../components/Sections/Categories";
export default {
    components: {
        LayoutDefault,
        Categories,
    },
}
</script>

<style scoped lang="scss">
</style>
